// SEE: https://github.com/date-fns/date-fns/pull/3151

const ISO_DURATION_REGEX = /P(?:([\d]+\.?[\d]*|\.[\d]+)Y)?(?:([\d]+\.?[\d]*|\.[\d]+)M)?(?:([\d]+\.?[\d]*|\.[\d]+)W)?(?:([\d]+\.?[\d]*|\.[\d]+)D)?(?:T(?:([\d]+\.?[\d]*|\.[\d]+)H)?(?:([\d]+\.?[\d]*|\.[\d]+)M)?(?:([\d]+\.?[\d]*|\.[\d]+)S)?)?$/;

/**
 * @name parseISODuration
 * @category Common Helpers
 * @summary Parse ISO Duration string
 *
 * @description
 * Parse the given string in ISO 8601 format and return Duration object.
 *
 * Function accepts duration format of ISO 8601.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * Specifically: https://en.wikipedia.org/wiki/ISO_8601#Durations
 *
 * If the argument is not a valid ISO Duration it will throw Invalid format error.
 *
 * @param argument - ISO Duration string
 * @returns Parsed duration object
 *
 * @throws It throws an "Invalid format" error if the string doesn't match the ISO Duration format
 *
 * @example
 * // Convert string 'P3Y6M4DT12H30M5S' to duration:
 * const result = parseISODuration('P3Y6M4DT12H30M5S')
 * //=>
 * const result = {
 *   years: 3,
 *   months: 6,
 *   weeks: 0,
 *   days: 4,
 *   hours: 12,
 *   minutes: 30,
 *   seconds: 5,
 * }
 */

export default function parseISODuration(argument) {
  const parsedArgument = argument.replace(/,/g, '.');

  const match = parsedArgument.match(ISO_DURATION_REGEX);

  if (!match) {
    throw new RangeError('Invalid format');
  }

  const [
    ,
    years = 0,
    months = 0,
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
  ] = match;

  const entries = Object.entries({
    years,
    months,
    weeks,
    days,
    hours,
    minutes,
    seconds,
  });

  return entries.reduce((prev, [key, value]) => {
    // eslint-disable-next-line no-param-reassign
    prev[key] = +value;
    return prev;
  }, {});
}
